<template>
  <div class="container">
    <card>
      <listItem :label="name" :color="'#999999'">
        <right :txtColor="'#333333'" :title="info.nameText" :rightShow="false"></right>
      </listItem>
      <rline v-if="type!==''"></rline>
      <listItem :label="type" :color="'#999999'" v-if="type!==''">
        <right :txtColor="'#333333'" :title="info.typeText" :rightShow="false"></right>
      </listItem>
      <rline v-if="date"></rline>
      <listItem :label="date" v-if="date" :color="'#999999'">
        <right :txtColor="'#333333'" :title="info.dateText.substring(0,10)" :rightShow="false"></right>
      </listItem>
    </card>
    <card class="mt12">
      <listItem :label="score"  :color="'#999999'">
        <right :txtColor="typeIndex >= 2 ? '#FF4D4D':'#36B374'" :title="info.scoreText + ''" :rightShow="false"></right>
      </listItem>
      <rline></rline>
      <listItem :label="updatetime" :color="'#999999'">
        <right :txtColor="'#333333'" :title="info.updatetimeText" :rightShow="false"></right>
      </listItem>
    </card>
    <card class="mt12" v-if="info.titleText!==''">
      <div class="title">{{title}}</div>
      <div class="desc">
        {{info.titleText}}
      </div>
    </card>
    <div class="enclosure" v-if="info.attch.length > 0">附件</div>
    <div class="imgs">
      <img class="img" v-for="(item,index) in info.attch" :key="index" :src="item.url" @click="onDialogOpen(info.attch,index)"/>
    </div>
  </div>
</template>
<script>
    import { ImagePreview } from 'vant';
    import card from '../travelAgency/components/card'
    import right from './components/right'
    import listItem from './components/list-item'
    import rline from '../travelAgency/components/line'
    export default {
        components: {
            card,
            listItem,
            right,
            rline
        },

        data () {
            return {
                name: '',
                type: '',
                date: '',
                score: '',
                updatetime: '',
                title: '',
                info: {
                    nameText: '',
                    typeText: '',
                    dateText: '',
                    scoreText: '',
                    updatetimeText: '',
                    titleText: '',
                    attch: []
                },
                typeIndex: 0
            }
        },

        computed: {},

        watch: {},

        methods: {
            // onDialogOpen (attachList) {
            //     let photos = []
            //     attachList.forEach(element => {
            //         photos.push(element.url)
            //     });
            //     let credentialsPhoto = [{ name: '附件', photos: photos }]
            //     this.$router.push({ path: '/guide/photo', query: { credentialsPhoto: JSON.stringify(credentialsPhoto) } })
            // }

            onDialogOpen (attachList, startPosition = 0) {
                let photos = []
                attachList.forEach(element => {
                    photos.push(element.url)
                });
                // let credentialsPhoto = [{ name: name, photos: photos }]
                // let photos = this.credentialsPhoto[index].photos
                ImagePreview({
                    images: photos,
                    startPosition: startPosition,
                    closeOnPopstate: true,
                    onClose () {
                        // do something
                    }
                });
                // this.$router.push({ path: '/guide/photo', query: { credentialsPhoto: JSON.stringify(credentialsPhoto) } })
            }
        },

        mounted () {
            let info
            if (this.$route.query.info) {
                info = JSON.parse(this.$route.query.info) || {}
            } else {
                info = JSON.parse(localStorage.getItem('guideChild')) || {}
                console.log('凯哥逻辑！')
            }
            console.log('info:', info)
            this.typeIndex = Number(this.$route.query.type)
            this.info.attch = info.attch || []
            this.info.updatetimeText = info.updateTime || ''
            this.info.dateText = info.date || ''
            let title = ''
            if (this.typeIndex === 0) {
                title = '表彰奖励或入选专家库、人才库'
                this.name = '奖励级别'
                this.type = '奖励类型'
                this.date = '奖励/证书发放日期'
                this.score = '奖励得分'
                this.updatetime = '更新日期'
                this.title = '奖励入选情况'
                this.info.nameText = info.awardLevel || ''
                this.info.typeText = info.awardType || ''
                this.info.scoreText = '+' + info.score || ''
                this.info.titleText = info.awardDesc || ''
            } else if (this.typeIndex === 1) {
                title = '参加公益活动'
                this.name = '公益活动名称'
                this.type = '举办方'
                this.date = '参加活动日期'
                this.score = '公益活动得分'
                this.updatetime = '更新日期'
                this.title = '公益活动情况'
                this.info.nameText = info.eventName || ''
                this.info.typeText = info.eventSponsor || ''
                this.info.scoreText = '+' + info.score || ''
                this.info.titleText = info.eventDesc || ''
            } else if (this.typeIndex === 2) {
                title = '行政处罚及其他违规行为'
                this.name = '类型'
                this.type = '详细类型'
                this.date = '处罚日期'
                this.score = '处罚扣分'
                this.updatetime = '更新日期'
                this.title = '行政处罚/违规行为详情'
                this.info.nameText = info.punishType || ''
                this.info.typeText = info.punishDetailType || ''
                this.info.dateText = info.date || ''
                this.info.scoreText = info.score || ''
                this.info.titleText = info.punishDesc || ''
            } else if (this.typeIndex === 3) {
                title = '其他不规范执业行为'
                this.name = '类型'
                this.type = ''
                this.date = '处罚日期'
                this.score = '处罚扣分'
                this.updatetime = '更新日期'
                this.title = '不规范执业行为情况'
                this.info.nameText = info.disorderType || ''
                this.info.typeText = ''
                this.info.scoreText = info.score || ''
                this.info.titleText = info.diorderDesc || ''
            }
            this.globalApp.setTitle(title)
        },

        created () {}

    }
</script>
<style scoped lang="less">
  .container {
    padding: 12px 16px;
    height: 100vh;
    background: @base-bgcolor;

    .title {
      padding: 16px 16px 12px 16px;
      font-size: 14px;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
    }

    .desc {
      font-size: 14px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 20px;
      padding-left: 16px;
      padding-right: 16px;
      padding-bottom: 16px;
    }

    .enclosure {
      margin-top: 16px;
      font-size: 14px;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
    }

    .imgs {
      img {
        display: inline-block;
        width: 77px;
        height: 77px;
        border-radius: 3px;
        margin-right: 14px;
        margin-top: 12px;
        object-fit: cover
      }
    }
  }
</style>
